var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"transfer-professional","route":"/reports/billing-transfer-professional","file-name":"repasse-por-profissional.xlsx","period-label":"Período do repasse","columns":_vm.columns,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }